import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Printer } from "lucide-react";
import { api, formatPrice } from "@/lib/api";

export default function Invoice() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/orders/${id}/invoice`).then((r) => setData(r.data)); }, [id]);

  if (!data) return <div className="ja-container py-32 text-center ja-serif text-2xl">Loading…</div>;
  const { order, customer, issued_at } = data;

  return (
    <div className="ja-container py-12 max-w-4xl" data-testid="invoice-page">
      <div className="flex justify-end mb-6 print:hidden">
        <button onClick={() => window.print()} className="ja-btn-outline flex items-center gap-2" data-testid="print-invoice">
          <Printer size={14} /> Print / Save PDF
        </button>
      </div>
      <div className="bg-white p-10 md:p-16 border" style={{ borderColor: "var(--ja-border)" }}>
        <div className="flex justify-between items-start pb-8 border-b" style={{ borderColor: "var(--ja-border)" }}>
          <div>
            <p className="ja-serif text-3xl">Jewels Ashu</p>
            <p className="text-xs mt-2" style={{ color: "var(--ja-muted)" }}>
              Pilu ka chowk Near Bada park Topkhana huzuri ghat gate jaipur, Rajastathan-302003·jewelsashu5@gmail.com<br/>
              GSTIN: 08AIKPI3690L1ZR
            </p>
          </div>
          <div className="text-right">
            <p className="ja-overline">Tax Invoice</p>
            <p className="ja-serif text-xl mt-2">{order.order_number}</p>
            <p className="text-xs mt-1" style={{ color: "var(--ja-muted)" }}>Issued {new Date(issued_at).toLocaleDateString()}</p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-6 py-8 border-b" style={{ borderColor: "var(--ja-border)" }}>
          <div>
            <p className="ja-overline">Billed To</p>
            <p className="mt-3 text-sm font-medium">{customer?.name}</p>
            <p className="text-sm" style={{ color: "var(--ja-muted)" }}>{customer?.email}</p>
          </div>
          <div>
            <p className="ja-overline">Shipped To</p>
            <p className="mt-3 text-sm font-medium">{order.address.full_name}</p>
            <p className="text-sm" style={{ color: "var(--ja-muted)" }}>
              {order.address.line1}{order.address.line2 ? `, ${order.address.line2}` : ""}<br/>
              {order.address.city}, {order.address.state} {order.address.pincode}<br/>
              {order.address.country} · {order.address.phone}
            </p>
          </div>
        </div>

        <table className="w-full text-sm mt-6">
          <thead>
            <tr className="text-left border-b" style={{ borderColor: "var(--ja-border)" }}>
              <th className="py-3 ja-overline font-normal">Item</th>
              <th className="ja-overline font-normal">SKU</th>
              <th className="ja-overline font-normal text-right">Qty</th>
              <th className="ja-overline font-normal text-right">Price</th>
              <th className="ja-overline font-normal text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {order.items.map((it, i) => (
              <tr key={i} className="border-b" style={{ borderColor: "var(--ja-border)" }}>
                <td className="py-4 ja-serif">{it.name}</td>
                <td>{it.sku}</td>
                <td className="text-right">{it.quantity}</td>
                <td className="text-right">{formatPrice(it.price, order.currency)}</td>
                <td className="text-right">{formatPrice(it.price * it.quantity, order.currency)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="mt-8 ml-auto max-w-xs space-y-2 text-sm">
          <div className="flex justify-between"><span>Subtotal</span><span>{formatPrice(order.subtotal, order.currency)}</span></div>
          {order.discount > 0 && <div className="flex justify-between"><span>Discount</span><span>− {formatPrice(order.discount, order.currency)}</span></div>}
          <div className="flex justify-between"><span>Shipping</span><span>Complimentary</span></div>
          <div className="flex justify-between pt-3 border-t" style={{ borderColor: "var(--ja-border)" }}>
            <span className="ja-serif text-lg">Total</span>
            <span className="ja-serif text-lg">{formatPrice(order.total, order.currency)}</span>
          </div>
          <p className="text-xs pt-3" style={{ color: "var(--ja-muted)" }}>Paid via {order.payment_method} · {order.payment_status}</p>
        </div>

        <p className="mt-12 text-center text-xs tracking-[0.3em] uppercase" style={{ color: "var(--ja-muted)" }}>
          Thank you for choosing Jewels Ashu.
        </p>
      </div>
    </div>
  );
}
